// extracted by mini-css-extract-plugin
export default {"more":"AvatarStack_more__-8BgF"};